import { render, staticRenderFns } from "./HistoryUnsavedView.vue?vue&type=template&id=59af8efe"
import script from "./HistoryUnsavedView.vue?vue&type=script&lang=ts"
export * from "./HistoryUnsavedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports